import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ConnectionTypeModel } from 'src/app/Model/ConnectionType.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { ComService } from 'src/app/Services/com-service/com.service';
import { ConnectionTypeService } from 'src/app/Services/connection-type/ConnectionType.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { RequestService } from 'src/app/Services/request/request.service';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
import { ConsultConnectionDataComponent } from '../../Components/consult-connection-data/consult-connection-data.component';
import { MyMessagesComponent } from '../../Components/my-messages/my-messages.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() url: string = null;
  @Input() queryparams: any = null;
  public type = null;
  public main;
  public PacoUrl = environment.request.paco;
  public agency;
  public tl: boolean = false;
  public radicado = null;
  public hidenav: boolean = true;
  public hideMain: boolean = false;
  public lang
  public activeLang = 'es';
  public name_type_connection = '';
  public conexionGroupName:string= '';
  public isNewiata: boolean = false;
  data: ConnectionTypeModel
  drawer: any;
  Languages: any[] = [
    { Id: "es", Name: "Colombia - Español" },
    { Id: "en", Name: "Estados Unidos - English" },
    { Id: "pt", Name: "Brazil - Português" }
  ];
  typeAgenciesName: { [types: string]: string } = {
    '2,2': 'AgenciaNueva.Titles.AgenciesPortal',
    '1,1': 'AgenciaNueva.Titles.AgenciesPortal',
    '1,3': 'AgenciaNueva.Titles.Sync',
    '1,4': 'AgenciaNueva.Titles.BSP',
    '3,4': 'AgenciaNueva.Titles.10',
    '1,5': 'AgenciaNueva.Titles.AgenciesPortalNDC',
    '4,4': 'AgenciaNueva.Titles.CreateSuperUserAndAdminPortal',
    '5,4': 'AgenciaNueva.Titles.ChangeSuperUserAndAdminPortal'
  };

  constructor(
    private readonly translate: TranslateService,
    private readonly Service: ConnectionTypeService,
    private readonly activeRoute: ActivatedRoute,
    private readonly lsService : SessionStorageService
  ) {

    this.lang = this.lsService.getLSItem('language')
    this.translate.setDefaultLang(this.lang);

  }

  async ngOnInit() {
    this.activeRoute.queryParams.subscribe((param) => {
      if (param.type != null) {
        this.type = param.type
        this.agency = true
      }
      else {
        this.type = param.type
        this.agency = false
        this.main = false
      }
    });

    this.activeRoute.queryParams.subscribe((param) => {
      if (param.lang == undefined) {

        if (this.lsService.getLSItem('language') == null) {

          this.lsService.setLSItem('language', this.activeLang)
          this.lang = this.lsService.getLSItem('language')
          this.translate.setDefaultLang(this.lang);

        }

      }
      else {
        this.lsService.setLSItem('language', param.lang)
        this.lang = this.lsService.getLSItem('language')
        this.translate.setDefaultLang(this.lang);
      }
    });


    if (this.type == null) {
      this.type = this.lsService.getLSItem('type')
    }
    if (this.type != null) {
      this.data = new ConnectionTypeModel();
      this.data.Id = +this.type
      await this.Service.getIdConnectionType(this.data).then(res => {

        this.name_type_connection = res.Name;

      });
    }
    let indexType=this.lsService.getLSItem("agencyType")+","+this.lsService.getLSItem("type")
    if(this.lsService.getLSItem('newiata') != undefined){
      this.isNewiata = true
      this.conexionGroupName='AgenciaNueva.Titles.nuevoIata'
    }
    else
      this.conexionGroupName=this.typeAgenciesName[indexType]

    this.lsService.agencyTypeObservable.subscribe(change=>{
      if(change){
        let indexTypeChangue=this.lsService.getLSItem("agencyType")+","+this.lsService.getLSItem("type")
        if(this.lsService.getLSItem('newiata') != undefined){
          this.isNewiata = true
          this.conexionGroupName='AgenciaNueva.Titles.nuevoIata'
        }
        else
          this.conexionGroupName=this.typeAgenciesName[indexTypeChangue]    
      }
    })
  }

  cleartype() {
    this.lsService.getLSItem("type")
  }

  /**
   * changeLanguage
   */
  public changeLanguage(lang) {
    this.translate.setDefaultLang(lang.value);
    this.lsService.setLSItem('language', lang.value)
    location.reload()
  }


}


@Component({
  selector: 'app-header-main',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderMainComponent implements OnInit {

  notifierSubscription: Subscription = this.dataService.subjectNotifier.subscribe(notified => {
    // originator has notified me. refresh my data here.
    this.ngOnInit()
  });

  public type: string = null;
  public hidenav: boolean = true;
  public request: RequestModel = new RequestModel();
  public lang;
  public tl: boolean = false;
  public main;
  public PacoUrl = environment.request.paco;
  public radicado = null;
  public agency;
  public activeLang = 'es';
  public name_type_connection = '';
  public hideMain: boolean = false;
  public isUpdateCrm: boolean = false;
  public conexionGroupName:string= '';
  data: ConnectionTypeModel
  drawer: any;
  typeAgenciesName: { [types: string]: string } = {
    '2,2': 'AgenciaNueva.Titles.AgenciesPortal',
    '1,1': 'AgenciaNueva.Titles.AgenciesPortal',
    '1,3': 'AgenciaNueva.Titles.Sync',
    '1,4': 'AgenciaNueva.Titles.BSP',
    '3,4': 'AgenciaNueva.Titles.10',
    '1,5': 'AgenciaNueva.Titles.AgenciesPortalNDC',
    '4,4': 'AgenciaNueva.Titles.CreateSuperUserAndAdminPortal',
    '5,4': 'AgenciaNueva.Titles.ChangeSuperUserAndAdminPortal'
  };
  Languages: any[] = [
    { Id: "es", Name: "Colombia - Español" },
    { Id: "en", Name: "Estados Unidos - English" },
    { Id: "pt", Name: "Brazil - Português" }
  ];

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly Service: ConnectionTypeService,
    private readonly activeRoute: ActivatedRoute,
    private readonly requestService: RequestService,
    private readonly DocumentService: DocumentService,
    private readonly modalService: NgbModal,
    private readonly dataService: ComService,
    private readonly lsService : SessionStorageService
  ) {

    if (this.lsService.getLSItem('language') != null) {
      this.lang = this.lsService.getLSItem('language')
      this.translate.setDefaultLang(this.lang);
    }
    else {
      this.lsService.setLSItem('language', this.activeLang)
      this.translate.setDefaultLang(this.activeLang);
      this.lang = this.activeLang
    }
  }

  async ngOnInit() {

    switch (this.activeRoute.snapshot.children[0].routeConfig.path) {
      case "TerminationLetter/:id":
        this.tl = true;
        break;
    }

    this.activeRoute.queryParams.subscribe(async (param) => {
      if (param.id != undefined) {
        await this.GetRequestById(param.id)
        this.type = this.lsService.getLSItem('type')
        this.main = true
      }
    })

    if (this.activeRoute.snapshot.children[0].params.requestcode != undefined) {
      if (this.activeRoute.snapshot.children[0].params.requestcode.includes('AVD')) {
        await this.GetRequestByCode()
        this.main = true
      }
      else {
        await this.GetRequestById(this.activeRoute.snapshot.children[0].params.requestcode)
        this.main = true
      }

    }
    else {
      this.activeRoute.queryParams.subscribe((param) => {
        if (param.requestcode == null) {
          this.type = this.lsService.getLSItem('type')
        }

        if (this.type != null) {
          this.main = true
          this.radicado = this.lsService.getLSItem('RequestCode')
        }
      });
    }

    if (this.type == null) {
      this.type = this.lsService.getLSItem('type')
    }
    if (this.type != null) {
      this.data = new ConnectionTypeModel();
      this.data.Id = +this.type
      await this.Service.getIdConnectionType(this.data).then(res => {

        this.name_type_connection = res.Name;

      });
    }

    if (this.router.url.toString().includes("/Register/Main/TermsRepository/")) {
      this.hideMain = true
    }
    if (this.lsService.getLSItem('isNewIata') != undefined) {
      this.isUpdateCrm = true
    }
    if (this.lsService.getLSItem('isUpdateCrm') != undefined) {
      this.isUpdateCrm = true
    }
    if (this.lsService.getLSItem('isUpdateCrmLocation') != undefined) {
      this.isUpdateCrm = true
    }

    let indexType=this.lsService.getLSItem("agencyType")+","+this.lsService.getLSItem("type")
    if(this.lsService.getLSItem('isUpdateCrm') != undefined)
      this.conexionGroupName='AgenciaNueva.Titles.updateRequest'
    else if(this.lsService.getLSItem('newiata') != undefined)
      this.conexionGroupName='AgenciaNueva.Titles.nuevoIata'
    else
      this.conexionGroupName=this.typeAgenciesName[indexType]

    this.lsService.agencyTypeObservable.subscribe(change=>{
      if(change){
        let indexTypeChangue=this.lsService.getLSItem("agencyType")+","+this.lsService.getLSItem("type")
        if(this.request.IsUpdateCrm || this.lsService.getLSItem('isUpdateCrm') != undefined)
          this.conexionGroupName='AgenciaNueva.Titles.updateRequest'
        else if(this.request.IsNewIata || this.lsService.getLSItem('newiata') || this.lsService.getLSItem('isNewIata') != undefined)
          this.conexionGroupName='AgenciaNueva.Titles.nuevoIata'
        else
          this.conexionGroupName=this.typeAgenciesName[indexTypeChangue]    
      }
    })
    
  }

  public async GetRequestById(id: string) {
    if (id != undefined) {
      await this.requestService.getRequestById(id)
        .then(async (res) => {
          if (res != null) {

            this.request = res

            this.lsService.setLSItem('RequestCode', res.RequestCode)
            this.lsService.setLSItem('IdRequest', res.Id.toString())
            this.lsService.setLSItem('type', res.ConnectionType.toString())
          }

          else {
            await Swal.fire({
              title: 'Error!',
              text: this.translate.instant('Home.Error'),
              icon: 'error'
            }
            )
          }
        }
        )
    }
    this.radicado = this.lsService.getLSItem('RequestCode')
  }


  public async GetRequestByCode() {
    if (this.radicado != undefined) {
      await this.DocumentService.getRequestByCode(this.radicado)
        .then(async (res) => {
          if (res != null) {
            this.request = res
            this.type = this.request.ConnectionType.toString()
            this.lsService.setLSItem('RequestCode', res.RequestCode)
            this.lsService.setLSItem('IdRequest', res.Id.toString())
            this.lsService.setLSItem('type', res.ConnectionType.toString())

          }
          else {
            await Swal.fire({
              title: 'Error!',
              text: this.translate.instant('Home.Error'),
              icon: 'error'
            }
            )
          }
        }
        )
    }
    else {
      await this.DocumentService.getRequestByCode(this.activeRoute.snapshot.children[0].params.requestcode)
        .then(async (res) => {
          if (res != null) {
            this.request = res
            this.type = this.request.ConnectionType.toString()
            this.lsService.setLSItem('RequestCode', res.RequestCode)
            this.lsService.setLSItem('IdRequest', res.Id.toString())
            this.lsService.setLSItem('type', res.ConnectionType.toString())
          }
          else {
            await Swal.fire({
              title: 'Error!',
              text: this.translate.instant('Home.Error'),
              icon: 'error'
            }
            )
          }
        }
        )
    }

    this.radicado = this.lsService.getLSItem('RequestCode')
  }

  /**
   * changeLanguage
   */
  public changeLanguage(lang) {
    this.translate.setDefaultLang(lang.value);
    this.lsService.setLSItem('language', lang.value)
    location.reload()
  }

  cleartype() {
    this.lsService.getLSItem("type")
    this.lsService.getLSItem("RequestCode")
  }

  openModalMyMessages() {
    const modalRef = this.modalService.open(MyMessagesComponent, { size: 'xl' });
    modalRef.componentInstance.type = this.type;
  }

  openModalConsulData() {
    const modalRef = this.modalService.open(ConsultConnectionDataComponent, { size: 'lg' });
    modalRef.componentInstance.type = this.type;
  }

  redirect() {
    window.location.replace(`Register/Main/ConsultConnectionData`);
  }

  public SendToPaco() {
    window.location.href = environment.request.paco;
  }

}
